/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UnauthorizedComponent } from '../modules/shared/unauthorized/unauthorized.component';
import { ToastrService } from 'ngx-toastr';
import { ErrorMessage } from '../appsettings';
import { ConfigService } from './config/config.service';
import { ThemeNames } from '../models/themes.enum';
import { ToasterService } from '../components/blue-pulse-theme-myprofile/services/toaster.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  public disableError: boolean;
  private isBluePulseTheme: boolean;

  constructor(
    private readonly matDialog: MatDialog,
    public readonly toastrService: ToastrService,
    public readonly toastr: ToasterService,
    private readonly configService: ConfigService,
  ) {
    
  }

  handleError(error: any): void {
    if (this.disableError) return;

    const status = error.status || error.Status;
    const errorResponse = error.error || error.Error;
    const errorMessage = errorResponse?.message || errorResponse?.Message;

    this.isBluePulseTheme = this.configService._envConfig.ThemeName.toLowerCase() === ThemeNames.BLUE_PULSE;

    if (errorMessage === ErrorMessage.MFA_EXCEED_ERROR_CODE && this.isBluePulseTheme) {
      window.location.href = `${this.configService.baseAuthUrl}/Account/Login?activation-status=max-mfa-error`;
    }

    this.handleStatus(status, errorResponse);
  }

  public handleStatus(status: number, errorResponse: any) {
    // Handle specific HTTP status codes
    if (status === 401) {
      this.handleUnauthorized();
    } else if (status === 403) {
      this.handleForbidden();
    } else if (status === 404) {
      this.handleNotFound(errorResponse);
    } else if (status >= 500) {
      this.handleServerError(errorResponse);
    } else {
      this.handleGenericError(errorResponse);
    }
  }

  private handleNotFound(error: any): void {
    const message = error.message || error.Message || error.error;

    if (this.isBluePulseTheme) {
      this.toastr.showToast({
        message: message,
        type: 'error',
        timeout: 5000,
      });
      return;
    }
    this.toastrService.error(message, null, { timeOut: 5000 });
  }

  private handleServerError(error: any): void {
    const message = error.message || error.Message || error.error;
    if (this.isBluePulseTheme) {
      this.toastr.showToast({
        message: message,
        type: 'error',
        timeout: 5000,
      });
      return;
    }
    this.toastrService.error(message, null, { timeOut: 5000 });
  }

  private handleGenericError(error: any): void {
    const message = error.message || error.Message || error.error;
    if (this.isBluePulseTheme) {
      this.toastr.showToast({
        message: message,
        type: 'error',
        timeout: 5000,
      });
      return;
    }
    this.toastrService.error(message, null, { timeOut: 5000 });
  }

  protected handleUnauthorized(): void {
    this.matDialog.open(UnauthorizedComponent, { disableClose: true });
  }

  protected handleForbidden(): void {
    this.matDialog.open(UnauthorizedComponent, { disableClose: true });
  }
}
